import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Storage from '../utils/storageES.js'

function QuickExpenseForm({ onClose, onSaved }) {
  const { t } = useTranslation()
  const [amount, setAmount] = useState('')
  const [category, setCategory] = useState('food')
  const [saved, setSaved] = useState(false)

  const categories = [
    { id: 'food', icon: '🍽️' },
    { id: 'transport', icon: '🚌' },
    { id: 'activities', icon: '🎯' },
    { id: 'shopping', icon: '🛍️' },
    { id: 'accommodation', icon: '🏨' },
    { id: 'other', icon: '📦' }
  ]

  const handleSave = () => {
    const parsedAmount = parseFloat(amount)
    if (!parsedAmount || parsedAmount <= 0) return

    const budgetData = Storage.get('budgetData') || {
      totalBudget: 0,
      dailyBudget: 0,
      categories: {},
      spentToday: 0,
      totalSpent: 0
    }

    const updatedBudget = {
      ...budgetData,
      categories: {
        ...budgetData.categories,
        [category]: (budgetData.categories[category] || 0) + parsedAmount
      },
      spentToday: (budgetData.spentToday || 0) + parsedAmount,
      totalSpent: (budgetData.totalSpent || 0) + parsedAmount
    }

    Storage.set('budgetData', updatedBudget)
    setSaved(true)
    setTimeout(() => {
      if (onSaved) onSaved()
      if (onClose) onClose()
    }, 800)
  }

  if (saved) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '30px 20px'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '12px' }}>✅</div>
        <div style={{
          fontSize: '18px',
          fontWeight: '700',
          color: '#8B7355'
        }}>{t('quickExpense.saved')}</div>
      </div>
    )
  }

  return (
    <div style={{ padding: '0 4px' }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: '700',
        color: '#8B7355',
        margin: '0 0 16px 0',
        textAlign: 'center'
      }}>{t('quickExpense.title')}</h3>

      {/* Category Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '8px',
        marginBottom: '16px'
      }}>
        {categories.map(cat => (
          <button
            key={cat.id}
            onClick={() => setCategory(cat.id)}
            style={{
              background: category === cat.id ? '#5B8FA8' : 'white',
              color: category === cat.id ? 'white' : '#8B7355',
              border: category === cat.id ? '2px solid #B8A082' : '2px solid #e0d5c5',
              borderRadius: '12px',
              padding: '10px 6px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'all 0.2s ease'
            }}
          >
            <div style={{ fontSize: '20px', marginBottom: '4px' }}>{cat.icon}</div>
            {t(`quickExpense.categories.${cat.id}`, cat.id)}
          </button>
        ))}
      </div>

      {/* Amount Input */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: '#8B7355',
          marginBottom: '6px'
        }}>{t('quickExpense.amount')}</label>
        <input
          type="number"
          inputMode="decimal"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="0.00"
          style={{
            width: '100%',
            padding: '14px 16px',
            fontSize: '24px',
            fontWeight: '700',
            textAlign: 'center',
            border: '2px solid #e0d5c5',
            borderRadius: '12px',
            outline: 'none',
            color: '#8B7355',
            background: 'white',
            boxSizing: 'border-box'
          }}
          autoFocus
        />
      </div>

      {/* Save Button */}
      <button
        onClick={handleSave}
        disabled={!amount || parseFloat(amount) <= 0}
        style={{
          width: '100%',
          padding: '14px',
          background: (!amount || parseFloat(amount) <= 0) ? '#d5cfc5' : 'linear-gradient(135deg, #B8A082, #8B7355)',
          color: 'white',
          border: 'none',
          borderRadius: '12px',
          fontSize: '16px',
          fontWeight: '700',
          cursor: (!amount || parseFloat(amount) <= 0) ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s ease'
        }}
      >
        {t('quickExpense.submit')}
      </button>
    </div>
  )
}

export default QuickExpenseForm
